import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import helperTime from "../../../helpers/time";
import StatePositionConstant from "./StatePositionConstant";
import sizesBanner from "./sizes-banner";
import validationsAddPosition from "../../../validations/forms/position/add";

export default function EditPositions() {
  const history = useHistory();
  const params = useParams();
  const positionID = params.positionID;
  const [message, setMessage] = useState();
  const [basePrice, setBasePrice] = useState(10000);
  const [count, setCount] = useState(0);
  const [price, setPrice] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [pageID, setPageID] = useState();
  const [active, setActive] = useState(false);
  const [page, setPage] = useState({});
  const [scoreAlternative, setScoreAlternative] = useState(0);
  const [activeAlternative, setActiveAlternative] = useState(true);
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    scrollForSeeMessage(".card-body");
    getPosition();
  }, []);

  useEffect(() => {
    changePrice();
  }, [basePrice]);

  useEffect(() => {
    changePrice();
  }, [count]);

  useEffect(() => {
    calculateScoreAlternative();
  }, [activeAlternative]);

  const changePrice = () => {
    if (!(count > 0)) {
      setPrice(0);
      return;
    }
    setPrice(Math.floor(basePrice / count));
  };

  useEffect(() => {
    if (price < 0) {
      return;
    }
    calculateScoreAlternative();
  }, [price]);

  const calculateScoreAlternative = () => {
    const scoreAlternative =
      price > parseInt(process.env.REACT_APP_MAX_SCORE_ALTERNATIVE_POSITION)
        ? parseInt(process.env.REACT_APP_MAX_SCORE_ALTERNATIVE_POSITION)
        : price;

    setScoreAlternative(scoreAlternative);
  };

  const getPage = async (pageID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let page = await sendRequestGetPage(pageID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!page) {
      return;
    }

    setPage(page);
  };

  const sendRequestGetPage = async (pageID) => {
    const headersRequest = getHeaderRequest();
    let page;
    try {
      page = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/page/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return page.data.data;
  };

  const getPosition = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let position = await sendRequestGetPosition(positionID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!position) {
      return;
    }

    let size = position.size.split("-");
    setWidth(size[0]);
    setHeight(size[1]);
    setCount(position.count);
    setBasePrice(position.base_price);
    setPrice(position.price);
    setActive(position.active);
    setPageID(position.page_id);
    setActiveAlternative(position.allow_alternative);
    setScoreAlternative(position.score_alternative);
    await getPage(position.page_id);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetPosition = async (positionID) => {
    const headersRequest = getHeaderRequest();
    let position;
    try {
      position = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/publisher/position/" +
          positionID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return position.data.data;
  };

  const generateButtonsSize = () => {
    return sizesBanner.map((sizeBanner) => {
      return (
        <div className="col-6 col-md-2 py-2">
          <div
            onClick={(e) => {
              e.preventDefault();
              setWidth(sizeBanner.width);
              setHeight(sizeBanner.height);
            }}
            className="btn btn-primary letter-spacing-finance-number p-2"
          >
            {helpersNumbers.toPersianNum(sizeBanner.height)}
            {"    "}-{"    "}
            {helpersNumbers.toPersianNum(sizeBanner.width)}
          </div>
        </div>
      );
    });
  };

  const inputPriceChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setBasePrice(parseInt(number));
  };

  const inputPriceBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".card-body");
    element.scrollIntoView();
  };

  const sendForm = async () => {
    const dataForm = getDataForm();
    const resultValidationsAddPosition = validationsAddPosition(dataForm);
    if (resultValidationsAddPosition != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidationsAddPosition,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }
    dataForm.page_id = pageID + "";

    await editPosition(positionID, dataForm);
  };

  const editPosition = async (positionID, dataForm) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultSendRequestEditPosition = await sendRequestEditPosition(
      positionID,
      dataForm
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestEditPosition) {
      return;
    }
    history.push(`/positions/all/page/${pageID}`);
  };

  const sendRequestEditPosition = async (positionID, dataForm) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/publisher/position/" +
          positionID,
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getDataForm = () => {
    return {
      count: count + "",
      base_price: basePrice + "",
      price: price + "",
      height: height + "",
      width: width + "",
      active: +active,
      allow_alternative: activeAlternative,
    };
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="ویرایش جایگاه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to={`/positions/${positionID}/view`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="alert alert-warning">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      تبلیغ بنری جایگزین تبلیغی است که درصورت نبود تبلیغ در
                      جایگاه , نمایش داده میشود و به کاربر نمایش دهنده Hicoin
                      تعلق میگرد
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      Hicoin تبلیغ بنری جایگزین برابر است با مبلغ تبلیغ یک بنر
                      در یک شبانه در صورتیکه مبلغ تبلیغ یک بنر در یک شبانه روز
                      کمتر از ۵۰۰۰ هزار باشد
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      حداکثر Hicoin تبلیغ بنری جایگزین برابر با ۵۰۰۰ است
                    </p>
                  </li>
                </ul>
              </div>

              {messageTag}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendForm();
                }}
              >
                <div className="form-group">
                  <label>تعداد بنر در جایگاه</label>
                  <input
                    tabIndex="1"
                    dir="ltr"
                    type="number"
                    id="count"
                    value={count}
                    onChange={(e) => {
                      e.preventDefault();
                      setCount(parseInt(e.target.value));
                    }}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>مبلغ پایه </label>
                  <input
                    tabIndex="2"
                    type="text"
                    id="price"
                    className="form-control number-finance"
                    value={helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(basePrice)
                    )}
                    onChange={inputPriceChangeHandler}
                    onBeforeInput={inputPriceBeforeInputHandler}
                    dir="ltr"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>مبلغ نمایش یک تبلیغ در یک شبانه روز :‌ </label>
                  <span
                    className="letter-spacing-finance-number"
                    style={{ fontSize: "22px" }}
                  >
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(price)
                    )}
                  </span>
                </div>

                <div className="form-group">
                  <label className="pl-2">فعال بودن تبلیغ جایگزین بنری</label>
                  <span>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active-advertise-alternative"
                        checked={activeAlternative}
                        onChange={() => {
                          setActiveAlternative(!activeAlternative);
                        }}
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                {activeAlternative && (
                  <div className="form-group">
                    <label>
                      Hicoin نمایش یک تبلیغ بنری جایگزین در یک شبانه روز :{" "}
                    </label>
                    <span
                      className="letter-spacing-finance-number"
                      style={{ fontSize: "22px" }}
                    >
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(scoreAlternative)
                      )}
                    </span>
                  </div>
                )}

                <div className="form-group">
                  <div className="pb-3">
                    <label>اندازه بنرهای تبلیغاتی ( ارتفاع - عرض) پیکسل</label>
                    <div className="container-fluid">
                      <div className="row">{generateButtonsSize()}</div>
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-md-row">
                    <div className="pl-0 pl-md-2">
                      <label>ارتفاع</label>

                      <input
                        dir="ltr"
                        type="number"
                        id="height"
                        value={height || ""}
                        className="form-control"
                        required
                      />
                    </div>
                    <div>
                      <label>عرض</label>
                      <input
                        dir="ltr"
                        type="number"
                        id="width"
                        value={width || ""}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <span className="pl-2">
                    <label>فعال</label>
                  </span>
                  <span>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active"
                        checked={active}
                        onChange={() => {
                          setActive(!active);
                        }}
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                <div className="form-group">
                  <button className="btn btn-success">ویرایش کردن</button>
                </div>

                <div className="form-group">
                  <div className="border border-success">
                    <a
                      href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${page?.img_name}`}
                      target="_blank"
                    >
                      <img
                        className="img-fluid"
                        src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${page?.img_name}`}
                      />
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
